<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Networks"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <l-csv-import @on-import="onImportNetworks" />
    </l-container>

    <l-csv-export :exportPlugin="exportPlugin" :show="networks.length > 0" filename="networks" />

    <hot-table :data="networks" :settings="settings" ref="hot">
      <hot-column title="Id" data="id" read-only="true"></hot-column>
      <hot-column title="Name" data="name" read-only="true"></hot-column>
      <hot-column title="Media monitored" data="media_monitored_name" read-only="true"></hot-column>
      <hot-column title="Responsible authority" data="responsible_authority_name" read-only="true"></hot-column>
      <hot-column title="Organisational" data="organisational_name" read-only="true"></hot-column>
      <hot-column title="Timezone" data="aggregation_timezone_name" read-only="true"></hot-column>
      <hot-column title="Begin position" data="begin_position" read-only="true"></hot-column>
      <hot-column title="End position" data="end_position" read-only="true"></hot-column>
    </hot-table>

    <l-l-edit
      :showing="edit"
      @save="onSaveNetwork"
      @close="edit = false"
      :network="selected"
      :timezones="timezones"
      :organisationallevels="organisationallevels"
      :mediavalues="mediavalues"
      :responsible_authorities="responsible_authorities"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import NetworksService from "@/helpers/services/management/networks.service";
import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";
import LCsvExport from '@/components/LCsvExport.vue';

export default {
  name: "Networks",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport,
    LCsvExport
  },
  data() {
    return {
      edit: false,
      loading: false,
      networks: [],
      responsible_authorities: [],
      timezones: [],
      organisationallevels: [],
      mediavalues: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      selected: {},
      isnew: false,
      exportPlugin: {}
    };
  },
  mounted() {
    //this.settings.afterSelectionEnd = this.selectRowOnly;
    this.exportPlugin = this.$refs.hot.hotInstance.getPlugin("exportFile");
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.organisationallevels = await NetworksService.organisationallevels();
      this.mediavalues = await NetworksService.mediavalues();
      this.timezones = await NetworksService.timezones();
      this.responsible_authorities = await NetworksService.responsible_authorities();
      this.networks = await NetworksService.networks();
    },
    // async deleteNetwork(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await NetworksService.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Network deleted!");
    //   }
    // },
    async saveNetwork(network) {
      const rowsAffected = await NetworksService.update(network);
      const current = this.networks.find(n => n.id == network.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && network[prop]) {
            current[prop] = network[prop];
          }
        }
      }
    },
    async importNetworks(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await NetworksService.import(formData);
      this.networks = await NetworksService.networks();
      Notify.success("Networks imported!");
    },
    async onImportNetworks(file) {
      await Notify.loadData("Importing networks", this.importNetworks, file);
    },
    onEditNetwork(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;
    },
    onNewNetwork(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteNetwork(t, o) {
      const endRow = o[0].end.row;
      const startRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              for (let index = startRow; index < endRow+1; index++) {
                var row = hot.getDataAtRow(index);
                const rowsAffected = await NetworksService.delete(row[0]);
              }
              const activeEditor = hot.getActiveEditor();
              hot.alter('remove_row', startRow, endRow-startRow+1);
              Notify.success("Network deleted!");
            }
          );
        }
      }, "This will delete all data connected to this Network(s). <br/><br/>Do you want to continue?");
    },

    async onSaveNetwork(network) {
      await Notify.loadData(
        "Saving changes to network " + network.id,
        this.saveNetwork,
        network
      );
      this.selected = {};
    }
  }
};
</script>

<style lang="postcss">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.2/css/all.min.css";
</style>

